(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/api/assets/javascripts/fetch-last-wins.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/api/assets/javascripts/fetch-last-wins.js');
"use strict";

let logger;
let jupiter;
if (svs.isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  logger = trinidad.logger('module:bingo_react:components:api:fetchLastWins');
  jupiter = trinidad.jupiter;
} else {
  logger = svs.core.log.getLogger('module:bingo_react:components:api:fetchLastWins');
  jupiter = svs.core.jupiter;
}
const fetchLastWins = async req => {
  try {
    const fetchOptions = {
      method: 'GET',
      path: '/bingo/1/lastwins'
    };
    if (svs.isServer) {
      fetchOptions.req = req;
    }
    const result = await jupiter.callAsync(fetchOptions);
    const lastWins = svs.isServer ? result.lastWins : result.response.lastWins;
    return lastWins;
  } catch (e) {
    logger.error("Error fetching lastWins ".concat(e), req);
    throw e;
  }
};
if (svs.isServer) {
  module.exports = fetchLastWins;
} else {
  setGlobal('svs.bingo_react.components.api.fetchLastWins', fetchLastWins);
}

 })(window);